import { render, staticRenderFns } from "./Telegestion.vue?vue&type=template&id=83168ad0&"
import script from "./Telegestion.vue?vue&type=script&lang=js&"
export * from "./Telegestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports